<template>
<transition name="gi-nav-fade">
  <div class="gi-nav is-fix" :class="{'is-show':ready}" v-show="!transparent">
    <div class="gi-nav-container">
      <div class="nav-item">
        <a
        v-if="logo" class="logo" :href="logo.href"
        target="_blank" style="position:relative; top: -5px"><img :src="logo.img" /></a>
      </div>
      <div class="nav-right">
        <div class="nav-menu is-tablet">
          <a v-for="m in menu.list" v-if="m['是否显示']" class="nav-item" :href="m.link">{{m.name}}</a>
        </div>
        <div class="nav-item" @click="showMobileMenu = !showMobileMenu">
          <a class="gi-nav-hamburger" :class="{'is-active': showMobileMenu}"><i></i><i></i><i></i></a>
        </div>
      </div>
    </div>
    <transition name="gi-nav-fade">
    <div class="nav-menu is-mobile" v-show="showMobileMenu">
      <ul class="list">
        <a v-for="m in menu.list" v-if="m['是否显示']" class="item" :href="m.link" @click="showMobileMenu=false">{{m.name}}</a>
      </ul>
    </div>
    </transition>
  </div>
</transition>

</template>

<script>
export default {
  props: ['menu', 'logo'],
  data () {
    return {
      showMobileMenu: false,
      scrollTop: 0,
      screenWidth: 0,
      ready: false
    }
  },
  computed: {
    transparent () {
      // let screenWidth = 0
      // if (window.innerWidth) {
      //   screenWidth = window.innerWidth
      // } else if ((document.body) && (document.body.clientWidth)) {
      //   screenWidth = document.body.clientWidth
      // }
      return this.scrollTop < 200
    }
  },
  created () {
    if (window.location.protocol.indexOf('file') > -1 ||
        window.location.search.indexOf('status=editing') > -1) {
      this.status = 'editing'
    }
    this.ready = true
    window.addEventListener('scroll', () => {
      this.scrollTop = document.documentElement.scrollTop || document.body.scrollTop
    })
    window.addEventListener('resize', () => {
      if (window.innerWidth) {
        this.screenWidth = window.innerWidth
      } else if ((document.body) && (document.body.clientWidth)) {
        this.screenWidth = document.body.clientWidth
      }
    })
  }
}
</script>

<style lang="sass">
// nav
//  container
//    nav-left, nav-middle, nav-right
//      nav-item
//        logo
//          img
//        hanburger
//        nav-menu.is-tablet
//  nav-menu.is-mobile

$nav-container-width: 1100px
$nav-container-width-m: 92vw
$nav-primary: #1075d4
$nav-height-mobile: 55px
$nav-height-tablet: 65px
$nav-hamburger-size: 20px
$nav-menu-tablet-margin: 0
$nav-menu-mobile-padding: 4vw
$nav-bg: #000
$nav-text: #fff
$nav-link: #1075d4
$nav-text-size: 16px
$nav-z-index: 1000
$nav-speed: .3s

=mobile
  @media screen and (max-width: 768px)
    @content

=tablet
  @media screen and (min-width: 769px)
    @content

.gi-nav-hamburger
  cursor: pointer
  display: block
  +tablet
    display: none
  height: $nav-hamburger-size
  width: $nav-hamburger-size
  display: flex
  flex-direction: column
  justify-content: space-between
  i
    background-color: $nav-text
    display: block
    height: 2px
    width: 100%
    transition: all $nav-speed ease-out
  &.is-active
    i
      &:nth-child(1)
        width: $nav-hamburger-size*1.414
        transform: rotate(43deg)
        transform-origin: left top
      &:nth-child(2)
        opacity: 0
      &:nth-child(3)
        width: $nav-hamburger-size*1.414
        transform: rotate(-43deg)
        transform-origin: left bottom

.gi-nav-container
  width: $nav-container-width
  +mobile
    width: $nav-container-width-m
  margin: 0 auto
  display: flex
  justify-content: space-between
  height: 100%

.gi-nav-fade-enter-active, .gi-nav-fade-leave-active
  transition: opacity $nav-speed
.gi-nav-fade-enter, .gi-nav-fade-leave-to
  opacity: 0

.gi-nav
  display: flex
  justify-content: space-between
  z-index: $nav-z-index
  white-space: nowrap
  background-color: $nav-bg
  height: $nav-height-mobile
  +tablet
    display: none
  &.is-show
    +tablet
      display: block
  &.is-fix
    position: fixed
    left: 0
    width: 100%
    top: 0
    .nav-menu.is-mobile
      position: fixed
  .nav-left, .nav-middle, .nav-right, .nav-item, .nav-menu.is-tablet
    display: flex
    height: 100%
    flex-grow: 0
    flex-shrink: 0
  .nav-item
    align-items: center
  .logo
    display: flex
    height: 50%
    align-items: center
    margin-right: 10px
    a
      display: inline-flex
      height: 100%
    img
      height: 100%
  .nav-menu a
    color: $nav-text
    font-size: $nav-text-size
    &:hover
      color: $nav-link
  .nav-menu.is-tablet
    margin: $nav-menu-tablet-margin
    a:not(:first-child)
      margin-left: 30px
    .nav-item
      position: relative
    .nav-item::after
      content: ''
      position: absolute
      left: 0
      right: 0
      bottom: 0
      height: 4px
      transition: background $nav-speed
      background-color: #000
    .nav-item:hover::after
      background-color: $nav-primary
  .nav-menu.is-mobile
    position: fixed
    z-index: $nav-z-index
    left: 0
    width: 100%
    top: $nav-height-mobile
    bottom: 0
    overflow-y: auto
    background-color: $nav-bg
    padding: $nav-menu-mobile-padding
    .list > .item
      display: flex
      padding: 18px 0
      font-size: $nav-text-size
      line-height: 1
      border-bottom: 1px solid #3c3c3c
  +mobile
    .nav-menu.is-tablet
      display: none
  +tablet
    height: $nav-height-tablet
    transition: opacity $nav-speed
    .nav-menu.is-mobile
      display: none
    &.transparent
</style>



// WEBPACK FOOTER //
// src/components/nav/nav.vue